import script from "./routing.vue?vue&type=script&setup=true&lang=js"
export * from "./routing.vue?vue&type=script&setup=true&lang=js"

import "./routing.vue?vue&type=style&index=0&id=0c70fd71&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c70fd71"]])

export default __exports__